import {ComponentType, forwardRef, PropsWithoutRef, PropsWithRef, Ref, useContext, useEffect} from 'react';

import {isUnitTestMode} from 'config/staticConfig';
import {DataIDOptionalParams} from 'shared/Ensighten/types';
import {PageNameOverrideContext, getDataID} from 'shared/Ensighten/utils';
import {useForceUpdate} from 'utils/hooks';

export const withAnalyticsID = <PassedThroughProps,>(
  WrappedComponent: ComponentType<PassedThroughProps & PropsWithRef<any>>
) => {
  const WithAnalyticsID = forwardRef(
    (props: PropsWithoutRef<PassedThroughProps & DataIDOptionalParams>, ref: Ref<any>) => {
      const pageNameOverride = useContext(PageNameOverrideContext);
      const forceUpdate = useForceUpdate(isUnitTestMode);

      // Because the data id depends on context and window, react will not re-render automatically when these change
      // Without forcing the update, the dataID would include the last page's pageName
      // eslint-disable-next-line
      useEffect(forceUpdate, [getDataID(props.name, {...props}, pageNameOverride)]);

      return <WrappedComponent ref={ref} {...props} data-id={getDataID(props.name, {...props}, pageNameOverride)} />;
    }
  );
  return WithAnalyticsID;
};
